// Shared CDL pre-trip (DVIR) checklist — used by both the driver's phone flow
// and the admin report viewer so they always line up. Drivers default every
// line to OK and only flag defects.
export const PRETRIP_SECTIONS = [
  { section: 'Engine / Fluids', items: [
    { key: 'leaks',   label: 'No fluid leaks under truck' },
    { key: 'oil',     label: 'Oil level' },
    { key: 'coolant', label: 'Coolant level' },
    { key: 'belts',   label: 'Belts & hoses' },
  ] },
  { section: 'Cab', items: [
    { key: 'service_brake', label: 'Service brake' },
    { key: 'parking_brake', label: 'Parking brake' },
    { key: 'steering',      label: 'Steering mechanism (play & response)' },
    { key: 'horn',          label: 'Horn' },
    { key: 'gauges',        label: 'Gauges & warning lights' },
    { key: 'wipers',        label: 'Wipers & washer' },
    { key: 'mirrors',       label: 'Mirrors & windshield' },
    { key: 'seatbelt',      label: 'Seatbelt' },
    { key: 'emergency',     label: 'Emergency kit (triangles, extinguisher)' },
  ] },
  { section: 'Lights', items: [
    { key: 'headlights',   label: 'Headlights & high beams' },
    { key: 'turn_signals', label: 'Turn signals & 4-ways' },
    { key: 'brake_lights', label: 'Brake & tail lights' },
    { key: 'markers',      label: 'Markers & reflectors' },
  ] },
  { section: 'Tires & Wheels', items: [
    { key: 'tires',    label: 'Tire tread & condition' },
    { key: 'pressure', label: 'Tire pressure' },
    { key: 'lugs',     label: 'Wheels, rims & lug nuts' },
  ] },
  { section: 'Chassis', items: [
    { key: 'suspension', label: 'Suspension & springs' },
    { key: 'frame',      label: 'Frame & body' },
    { key: 'exhaust',    label: 'Exhaust' },
    { key: 'coupling',   label: 'Coupling / trailer (if towing)' },
  ] },
  { section: 'Brakes', items: [
    { key: 'air_brake', label: 'Air brake check' },
    { key: 'air_lines', label: 'Air lines & leaks' },
  ] },
];

// Extra section shown only for trucks flagged as crane/derrick, before lifting.
export const PRETRIP_CRANE_SECTION = {
  section: 'Pre-Lift (Crane / Digger)',
  items: [
    { key: 'outriggers',     label: 'Outriggers / stabilizers set' },
    { key: 'hydraulics',     label: 'Hydraulics — leaks & pressure' },
    { key: 'cable',          label: 'Wire rope / cable & hooks' },
    { key: 'boom',           label: 'Boom & controls function' },
    { key: 'load_chart',     label: 'Load chart on board' },
    { key: 'safety_devices', label: 'Safety devices / limit switches' },
  ],
};

export const PRETRIP_PHOTO_SIDES = ['Front', 'Left Side', 'Back', 'Right Side', 'Damage'];

// Flatten the sections a given truck should show into one ordered item list.
export function pretripItems(isCrane) {
  const secs = isCrane ? [...PRETRIP_SECTIONS, PRETRIP_CRANE_SECTION] : PRETRIP_SECTIONS;
  return secs.flatMap(s => s.items.map(it => ({ ...it, section: s.section })));
}
